import React from 'react';
import { Link } from 'react-router-dom';
import highlandsImage from '../../assets/neighborhoods/highlands.png';
import dawsonvilleImage from '../../assets/neighborhoods/dawsonville.png';

// This would typically come from an API or database
const neighborhoods = [
  {
    id: 'highlands',
    name: 'The Highlands',
    location: 'Rome, GA',
    description: 'Nestled in the rolling hills of Rome, this beautiful community offers stunning mountain views and easy access to downtown.',
    image: highlandsImage,
    priceRange: 'From the $400s'
  },
  {
    id: 'castleberry',
    name: 'Castleberry Ridge',
    location: 'Dawsonville, GA',
    description: 'Located in charming Dawsonville, this family-friendly neighborhood features spacious lots and excellent schools.',
    image: dawsonvilleImage,
    priceRange: 'From the $450s'
  }
];

const FeaturedNeighborhoods: React.FC = () => {
  return (
    <section className="section bg-gray-50 relative">
      {/* Design Element: Diagonal Cut Top */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-white transform skew-y-2 -translate-y-8"></div>
      
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="mb-4">Our Neighborhoods</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover our beautiful communities in prime Georgia locations, designed for modern family living.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {neighborhoods.map((neighborhood) => (
            <div key={neighborhood.id} className="bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-xl transition duration-300">
              <Link to={`/neighborhoods/${neighborhood.id}`} className="flex flex-col h-full">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={neighborhood.image} 
                    alt={neighborhood.name} 
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 p-6 text-white">
                    <h3 className="text-2xl font-serif mb-1">{neighborhood.name}</h3>
                    <p className="text-white/90">{neighborhood.location}</p>
                  </div>
                </div>
                <div className="p-6 flex-grow">
                  <p className="text-gray-600 mb-4">{neighborhood.description}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-primary font-medium">{neighborhood.priceRange}</span>
                    <span className="text-sm text-gray-500 group-hover:text-primary transition duration-300 flex items-center">
                      View Community 
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-10">
          <Link to="/neighborhoods" className="btn btn-outline">
            Explore All Neighborhoods
          </Link>
        </div>
      </div>
      
      {/* Design Element: Diagonal Cut Bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-white transform -skew-y-2 translate-y-8"></div>
    </section>
  );
};

export default FeaturedNeighborhoods; 